// extracted by mini-css-extract-plugin
module.exports = {"home":"Position_home__1TsTc","textFields":"Position_textFields__3ItWV","actionButton":"Position_actionButton__3L3BV","error":"Position_error__1ncp9"};